import MiracleFlowIcon from "@/assets/miracleflow.png";
import { LogoImage, LogoProps } from "../LogoImage";

type Props = Omit<LogoProps, "imgSrc" | "alt">;

export const MiracleFlowLogo = (props: Props) => (
  <LogoImage imgSrc={MiracleFlowIcon} alt="MiracleFlow Logo" size="navbar" {...props} />
);
